<template>
    <div class="beauty-product-sampling-page">
        <container size="lg">
            <section class="p-x-small-28">
                <Hero
                    image="new/main-home.png"
                    heading-text="The future of Beauty Product Sampling is Here!"
                    btn-text="Book for a Demo Session"
                    image-width="w-100"
                >
                    <template #content>
                        <div class="p-b-32">
                            <Texture
                                style="letter-spacing: -0.75px;"
                                size="x-sm"
                                tag="p"
                                color="primary"
                                class="f-w-600 m-0"
                            >
                                Let Peekage be your partner in your beauty product sampling journey. Try out the Peekage platform now.
                            </Texture>
                        </div>
                    </template>
                </Hero>
            </section>

            <section class="p-x-small-28 p-y-120">
                <center class="p-x-100 p-x-small-0">
                    <Heading
                        color="primary"
                        class="f-w-700 m-b-40 text-sm-left"
                        tag="h2"
                        size="web-xx-lg"
                    >
                        Cosmetic sampling service with Peekage
                    </Heading>

                    <Texture
                        color="secondary"
                        class="f-w-400 text-left"
                        tag="p"
                        size="x-lg"
                    >
                        There is no question that in beauty, sampling works. But what can a brand do in a covid and post-covid era that allows no touching, slathering, or swatching? <span class="d-block m-b-10" />
                        Gone are the days that a brand could set up a cosmetic counter in a beauty salon or a mall and offer to spray people with luxury fragrances or make-up makeovers. It is not sanitary anymore! Or maybe it never was! <span class="d-block m-b-10" />
                        In the pandemic era or even a post-covid world, potential customers are more likely to enjoy individualized and personal samples. This means smaller but private samples for each one of them.<span class="d-block m-b-10" />
                        Research has shown that people find small bottled cosmetic and skincare product samples more luxurious than having a skincare routine done on them or even having a make-up makeover in a public place. Moreover, small bottled beauty samples cost far less than having a full-sized product on display.<span class="d-block m-b-10" />
                        Using Peekage beauty product sampling service costs less, is more effective, and is more sanitary.
                    </Texture>
                </center>
            </section>

            <section class="p-x-small-28">
                <PeekagePlatform
                    heading-text="Try out Peekage Platform"
                    sub-title=""
                    :items="peekagePlatform"
                />
            </section>

            <section class="m-y-100" data-aos="fade-in">
                <div class="p-x-small-28">
                    <Heading
                        style="letter-spacing: -0.75px;"
                        size="sm"
                        tag="h2"
                        color="primary"
                        class="f-w-600 m-b-12"
                    >
                        Peekage Platform Provides
                    </Heading>
                    <div class="row">
                        <div class="col-md-6" v-for="(provide, i) in provides" :key="i" data-aos="fade-in">
                            <FeatureSmCard
                                :item="provide"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section class="p-l-small-0 p-r-small-0" data-aos="fade-in">
                <Banner
                    btn-text="Call Now"
                >
                    <template #content>
                        <div class="p-r-68 p-r-small-0 p-r-medium-0 p-r-large-0 text-center text-lg-left">
                            <Heading
                                color="on-color"
                                class="f-w-700 m-b-12"
                                tag="h2"
                                size="web-sm"
                            >
                                Beauty product samples are the third most significant driver of full-size product purchases.
                            </Heading>

                            <Texture
                                tag="p"
                                size="lg"
                                color="on-color"
                                class="f-w-700 m-b-0"
                            >
                                Book a free consultation with a beauty product sampling expert now.
                            </Texture>
                        </div>
                    </template>
                </Banner>
            </section>

            <section class="m-y-100" data-aos="fade-in">
                <div class="p-x-small-28">
                    <Heading
                        style="letter-spacing: -0.75px;"
                        size="sm"
                        tag="h2"
                        color="primary"
                        class="f-w-600 m-b-12"
                    >
                        Peekage Platform Features
                    </Heading>
                    <div class="row">
                        <div class="col-md-6" v-for="(feature, i) in features" :key="i" data-aos="fade-in">
                            <FeatureSmCard
                                :item="feature"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section class="m-t-200 m-b-100 m-t-small-100 m-b-small-0 m-t-large-100 m-b-large-0">
                <div class="p-x-200 p-x-small-28 p-x-large-28" data-aos="fade-in">
                    <Heading
                        style="letter-spacing: -0.75px;"
                        size="web-md"
                        tag="h3"
                        color="primary"
                        class="f-w-600 m-b-12"
                    >
                        Frequently asked questions
                    </Heading>

                    <div class="accordion">
                        <template v-for="(article, index) in faq">
                            <div
                                class="m-l-small-5 border-bottom p-y-24"
                                :key="index"
                                data-aos="fade-in"
                            >
                                <div class="accordion-item d-flex" v-b-toggle="`collapse-${index}`">
                                    <span class="accordion-item-icon icon chevron-right m-r-18 size sm color secondary" />
                                    <Texture
                                        size="md"
                                        tag="p"
                                        color="primary"
                                        class="f-w-600 m-b-0"
                                    >
                                        {{ article.title }}
                                    </Texture>
                                </div>
                                <b-collapse :id="`collapse-${index}`">
                                    <Texture
                                        style="white-space: break-spaces;"
                                        size="md"
                                        tag="pre"
                                        color="secondary"
                                        class="f-w-400 m-b-0 m-l-42 m-l-small-0"
                                        v-html="article.content"
                                    />
                                </b-collapse>
                            </div>
                        </template>
                    </div>
                </div>
            </section>

            <div class="mb-160">
                <blog-posts :posts="posts" />
            </div>
        </container>
    </div>
</template>

<script>
import AOS from 'aos';
import 'aos/dist/aos.css';
import LRUCache from 'lru-cache';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import { hydrateWhenVisible } from 'vue-lazy-hydration';
import { breadcrumb } from '~/scripts/utils/constants/structured-data/index';
import BlogPosts from '~/components/pages/home/blog-posts';
import PeekagePlatform from '~/components/common/list/counter/index';
import Hero from '~/components/common/hero';
import Banner from '~/components/common/banner';
import FeatureSmCard from '~/components/common/card/feature-sm';

const blogPostsCache = new LRUCache({
    max: 500,
    maxAge: 1000 * 60 * 60 * 24,
});
const postsCacheKey = 'BLOG_POSTS';

const { log } = console;

const peekagePlatform = [
    {
        title: '',
        text: 'Get a free consultation from our beauty product sampling experts, and devise your campaign.',
    },
    {
        title: '',
        text: 'Target your desired audience based on your brand user persona or let Peekage AI Algorithm choose a target market for you.',
    },
    {
        title: '',
        text: 'Choose one receive one sample product or pair up two or more of your beauty products, form a basket, or even let Peekage choose from a sample beauty product basket on your behalf with two or more other brands. Peekage will handle all inventory and shipments.',
    },
    {
        title: '',
        text: 'Analyze user feedback and watch your loyal customer base grow live on your dashboard.',
    },
    {
        title: '',
        text: 'Use gathered user data for retargeting campaigns. With Peekage, you can have your beauty product sampling campaign on auto-pilot. Peekage will handle 0 to 100 of the process, boost your sales, and provide you with valuable data.',
    },
];

const faq = [
    {
        title: 'How Peekage works?',
        content: 'Peekage aims to promote your product to its right consumers, get their feedbacks and boost your sales. This process begins with designing a customized campaign for your brand, launching the campaign, handling all shipment and warehousing, and getting consumer feedback in real-time.',
    },
    {
        title: 'Is Peekage suitable for small businesses too?',
        content: 'Yes. Peekage offers solutions for <a href="https://peekage.com/d2c-brands-solutions" target="_blank">small to medium businesses</a>, as well as <a href="https://peekage.com/enterprise-solutions" target="_blank">large enterprises</a>. Peekage campaigns are customized for each brand and are in line with their goals.',
    },
    {
        title: 'What sort of data does Peekage gathers from its users?',
        content: 'As a brand, you will gain access to demographic user data and their unbiased and unfiltered opinions on products of your choosing, integrated across all channels. You will have a generic data analytics dashboard to see what sort of data you can gain access to.',
    },
    {
        title: 'How Peekage chooses the right audience for a specific product?',
        content: 'In peekage, users answer several surveys to earn enough credits and claim a package. Not only will undesirable consumers for a specific product be filtered out during these surveys, but because every user chooses their own package, you can know beforehand that generally what sort of consumers find your brand attractive.',
    },
    {
        title: 'What kind of growth can a business expect when using Peekage?',
        content: 'While the goals of every business may vary, they share a common goal which is knowing their market and their consumers. Peekage gives businesses and brands different and customized plans curated to satisfy their various needs. You can choose a goal you’re comfortable with and grow at a rate that you want. Peekage will help you find the right consumers and adjust your campaign\'s intensity according to your goals. Peekage will connect you to your exact target audience, and by executing the campaigns at the right pace, makes sure that you will reach your goals.',
    },
    {
        title: 'How long does it take for a package to get delivered to consumers?',
        content: 'We always try our best to deliver your products to consumers as soon as possible. However, it may take up to 3 weeks in some areas. You can always track your products under shipping and fulfillment.',
    },
];

const provides = [
    {
        image: 'arts/Convert.svg',
        title: 'Technology',
        description: 'a user-friendly smart link for users to interact with your brand and an easy-to-use dashboard to collect user data for you.',
    },
    {
        image: 'arts/reviews-lg.svg',
        title: 'Consumer surveys and reviews',
        description: 'an open line of communication between your brand and your users. Find out what people say about your brand and why. Use consumer feedback to find what your niche market really desires.',
    },
    {
        image: 'arts/online-experience-lg.svg',
        title: 'Data analytics',
        description: 'an interactive and easy-to-understand data dashboard that provides user analytics in real-time.',
    },
    {
        image: 'arts/Opt-in-lg.svg',
        title: 'Packaging',
        description: 'Packaging and printing services up to your brand’s standards. A variety of packaging services and custom boxes will ensure your brand message will arrive intact to your consumer.',
    },
    {
        image: 'arts/Fulfilment-lg.svg',
        title: 'Warehousing and fulfillment',
        description: 'audited and certified warehouses across Canada, customized and suitable for your specific products. Round-the-clock pick and pack services to ensure fulfillment.',
    },
    {
        image: 'arts/Loyalty.svg',
        title: 'Online support',
        description: 'We will be with you and your consumers every step of the way. Our online support service will ensure you make a good impression on your consumers and will build trust.',
    },
];

export default {
    components: {
        BlogPosts: hydrateWhenVisible(BlogPosts),
        PeekagePlatform,
        Hero,
        Banner,
        FeatureSmCard,
    },
    layout: 'xerneas',
    async asyncData(context) {
        try {
            if (blogPostsCache.has(postsCacheKey)) {
                log('Blog Posts Have Been Cached');
                return {
                    posts: blogPostsCache.get(postsCacheKey),
                };
            }

            const postsResult = await context.app.$axios.get('https://peekage.com/blog/wp-json/wp/v2/posts');
            let posts = get(postsResult, 'data', []);

            posts = posts.map((post) => {
                const str = post.content.rendered;
                const regex = /\ssrc=(?:(?:'([^']*)')|(?:"([^"]*)")|([^\s]*))/i;
                const srcs = regex.exec(str).filter(Boolean);
                post = Object.assign({}, post, {
                    image: srcs[1] ? srcs[1] : '',
                });
                return post;
            });

            const postFirstChunk = chunk(posts, 3)[0];
            blogPostsCache.set(postsCacheKey, postFirstChunk);

            return {
                posts: postFirstChunk,
            };
        } catch (error) {
            return context.error({ statusCode: 500, message: error.message });
        }
    },
    data() {
        return {
            posts: [],
            peekagePlatform: [...peekagePlatform],
            structuredData: {
                '@context': 'https://schema.org',
                '@type': 'Organization',
                name: 'Peekage',
                alternateName: 'Peekage App',
                url: 'https://peekage.com',
                logo: 'https://peekage.com/logo-default.svg',
                sameAs: [
                    'https://www.facebook.com/peekageApp',
                    'https://twitter.com/peekageapp',
                    'https://www.instagram.com/peekageapp',
                    'https://www.linkedin.com/company/peekage',
                ],
            },
            structuredDataFAQ: [...faq],
            faq: [...faq],
            features: [
                { alt: 'Product strategy', image: 'arts/Targeting.svg', title: 'Product strategy', description: 'A professional team of marketers charting the best route for your brand.' },
                { alt: 'Product Specialists', image: 'arts/Collect Data.svg', title: 'Product Specialists', description: 'Hundreds of consumers, verified and active across Canada and the United States to provide feedback. Opt-in method, users choose products.' },
                { alt: 'Campaign managing', image: 'arts/Opt-in.svg', title: 'Campaign managing', description: 'A hands-on group of managers, measuring and adjusting your campaign in real-time, making targeting easy.' },
                { alt: 'Data analysis', image: 'arts/reviews-lg.svg', title: 'Data analysis', description: 'Gathering data and transforming it into usable information instantaneously for changing or maintaining ad channels.' },
                { alt: 'Inventory managing', image: 'arts/Fulfilment.svg', title: 'Inventory managing', description: 'Package tracking and status checking of your products. Shipping and fulfillment have been made easy.' },
                { alt: 'Reports', image: 'arts/Data.svg', title: 'Reports', description: 'Real-time analytical reports available for each product or campaign, usable for retargeting.' },
            ],
            provides: [...provides],
        };
    },
    head() {
        return {
            title: 'Beauty Product Sampling | Peekage: Digital Sampling Platform',
            __dangerouslyDisableSanitizers: ['script'],
            script: [
                { innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' },
                { innerHTML: JSON.stringify(this.structuredDataFAQ), type: 'application/ld+json' },
                { innerHTML: JSON.stringify(breadcrumb()), type: 'application/ld+json' },
            ],
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Try a new digital way to sample cosmetic & beauty products. Target the right consumers & get valuable insights in a way you can actually use. US/CA.',
                },
                {
                    property: 'og:title',
                    content: 'Peekage | Smart product sampling platform',
                    'data-hid': 'og:title',
                },
                {
                    property: 'og:url',
                    content: 'https://peekage.com',
                    'data-hid': 'og:url',
                },
                {
                    property: 'og:description',
                    content: 'Are you interested in a new product—but wanted to try it first? With Peekage, you can',
                    'data-hid': 'og:description',
                },
                {
                    property: 'og:image',
                    content: 'https://peekage.com/opengraph.png',
                    'data-hid': 'og:description',
                },
                {
                    property: 'twitter:title',
                    content: 'Peekage | Smart product sampling platform',
                    vmid: 'twitter:title',
                },
                {
                    property: 'twitter:url',
                    content: 'https://peekage.com',
                    vmid: 'twitter:url',
                },
                {
                    property: 'twitter:description',
                    content: 'Are you interested in a new product—but wanted to try it first? With Peekage, you can',
                    vmid: 'twitter:description',
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: 'https://peekage.com',
                },
            ],
        };
    },
    mounted() {
        AOS.init();
    },
};
</script>
